// extracted by mini-css-extract-plugin
export var legendIndicator = "_gx-1";
export var legendRight = "_gx-0";